import EmployeesSearchBarV2 from "./EmployeesSearchBarV2";

export default EmployeesSearchBarV2;
